import React from "react";
import NavOne from "./NavOne";

interface NavBarProps {
  handleEnrollButtonClick: () => void;
  handleBroutcherButtonClick: (broutcherLink?: string) => void;
  pageTitle?: any;
  data?: any;
}

const NavBar: React.FC<NavBarProps> = ({
  handleEnrollButtonClick,
  handleBroutcherButtonClick,
  pageTitle,
  data,
}) => {
  return (
    <NavOne
      pageTitle={pageTitle}
      handleEnrollButtonClick={handleEnrollButtonClick}
      data={data}
      handleBroutcherButtonClick={handleBroutcherButtonClick}
    />
  );
};

export default NavBar;
